import { render, staticRenderFns } from "./RegistrationInfo.vue?vue&type=template&id=e57ca29e&scoped=true"
import script from "./RegistrationInfo.vue?vue&type=script&lang=js"
export * from "./RegistrationInfo.vue?vue&type=script&lang=js"
import style0 from "./RegistrationInfo.vue?vue&type=style&index=0&id=e57ca29e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57ca29e",
  null
  
)

export default component.exports